import { render, staticRenderFns } from "./DraggableItems.vue?vue&type=template&id=eea4cd06&scoped=true&"
import script from "./DraggableItems.vue?vue&type=script&lang=js&"
export * from "./DraggableItems.vue?vue&type=script&lang=js&"
import style0 from "./DraggableItems.vue?vue&type=style&index=0&id=eea4cd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea4cd06",
  null
  
)

export default component.exports